import { PlusOutlined } from '@ant-design/icons';
import { Col, Divider, Form, Image, Input, InputNumber, Row, Select, Upload } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import addOnService from '../../../../services/config/add_on.service';
import RichTextEditor from '../../../../helpers/components/rich_text_editor';

const { TextArea } = Input;
const AddAddOnModal = ({ form, }) => {
    const [state, setState] = useState({
        loading : false,
        image : null,
        add_on_types : [],
        add_on_sections : [],

        selected_add_on_section : null,
    })

    const is_generate_code = useMemo(() => {
        return state?.selected_add_on_section?.is_generate_code;
    }, [state?.selected_add_on_section])

    const acceptable_file_format = ['image/jpeg', 'image/png'];
    const beforeUpload = async (file) => {
        const is_image = acceptable_file_format?.find(x => x == file?.type);

        if(is_image){
            const uploaded_file = await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => {
                    file.base64 = reader.result.split(',')[1];
                    resolve(file);
                };
                reader.onerror = (error) => reject(error);
            });
    
            const base64Image = `data:image/jpeg;base64,${uploaded_file?.base64}`;
            setState(state => ({...state, image : base64Image}));
        }else{
            // errorModal("Please upload in image format");
        }
        return false;
    }

    const fetchAddOnTypes = async () => {
        const addOnTypeResponse = await addOnService?.fetchAddOnType();

        const { add_on_types = [], } = addOnTypeResponse;
        return add_on_types;
    }

    const fetchAddOnSections = async () => {
        const addOnSectionResponse = await addOnService?.fetchAddOnSection();
        
        const { add_on_sections = [], } = addOnSectionResponse;
        return add_on_sections;
    }

    const onDeltaChange = (html) => {
        form.setFieldsValue({ description : html || null, });
    }

    const initialize = async () => {
        setState(state => ({...state, loading : false, }));
        const add_on_types = await fetchAddOnTypes();
        const add_on_sections = await fetchAddOnSections();

        setState(state => ({...state, add_on_types : add_on_types, add_on_sections : add_on_sections, loading : false, }));
    }

    useEffect(() => {
        initialize();
        
    }, [])

    return (
        <>
            <Form.Item label={"Image"} name={'image'}>
                <Upload
                name="company_logo"
                listType='picture-card'
                beforeUpload={beforeUpload}
                showUploadList={false}
                style={{width : '100%',}}
                >
                    {
                        state?.image ?
                        (
                            <>
                                <Image preview={false} src={state?.image} style={{ maxWidth : '100%', maxHeight : 102, objectFit : 'contain', }} />
                            </>
                        )
                        :
                        (
                            <>
                                <div>
                                    <div>
                                        <PlusOutlined />
                                    </div>
                                    <div>Upload</div>
                                </div>
                            </>
                        )
                    }
                </Upload>
            </Form.Item>

            <Form.Item label={"Name"} name={'name'}>
                <Input />
            </Form.Item>

            <Form.Item label={"Description"} name={'description'}>
                <div>
                    <RichTextEditor
                    placeholder='Enter descriptions'
                    onChange={onDeltaChange}
                    />
                </div>
            </Form.Item>

            <Form.Item label={"Add On Type"} name={'add_on_type_id'}>
                <Select
                placeholder={"Select Add On Type"}
                allowClear
                options={state?.add_on_types?.map(x => ({ label : x?.name, value : x?.add_on_type_id, }))}
                />
            </Form.Item>

            <Divider />
            <Row gutter={[12, 12]}>
                <Col span={12}>
                    <Form.Item label={"Add On Section"} name={'add_on_section_id'}>
                        <Select
                        onChange={(x, k) => setState(state => ({...state, selected_add_on_section : k, }))}
                        placeholder={"Select Add On Section"}
                        allowClear
                        options={state?.add_on_sections?.map(x => ({ label : x?.name, value : x?.add_on_section_id, is_generate_code : x?.is_generate_code, }))}
                        />
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <Form.Item label={"Reference Value"} name={'reference_quantity'}>
                        <InputNumber disabled={!is_generate_code} style={{ width : '100%', }} />
                    </Form.Item>
                </Col>
            </Row>
        </>
    );
}

export default AddAddOnModal;